import { combineReducers } from 'redux'
import agrupaciones from './agrupaciones'
import almacenes from './almacenes'
import articulo from './articulo'
import articulos from './articulos'
import articulosConjunto from './articulosConjunto'
import articulosKit from './articulosKit'
import auth from './auth'
import avisos from './avisos'
import banners from './banners'
import comunidadesAutonomas from './comunidadesAutonomas'
import contacto from './contacto'
import descripcion from './descripcion'
import domiciliosEnvio from './domiciliosEnvio'
import efacturaCompras from './efacturaCompras'
import efacturaVentas from './efacturaVentas'
import estados from './estados'
import expedientes from './expedientes'
import familias from './familias'
import festivos from './festivos'
import formasEnvio from './formasEnvio'
import formasPago from './formasPago'
import galeria from './galeria'
import imagen from './imagen'
import informes from './informes'
import informesFiltroLov from './informesFiltroLov'
import languageSelector from './languageSelector'
import listadoArticulos from './listadoArticulos'
import listasCompra from './listasCompra'
import loader from './loader'
import messages from './messages'
import migas from './migas'
import modalGenerica from './modalGenerica'
import modular from './modular'
import ofertasMultiples from './ofertasMultiples'
import ofertasWeb from './ofertasWeb'
import organizacionesCompras from './organizacionesCompras'
import pedidos from './pedidos'
import pedidosAnteriores from './pedidosAnteriores'
import pedidosPendientes from './pedidosPendientes'
import plantillas from './plantillas'
import portal from './portal'
import precios from './precios'
import presentaciones from './presentaciones'
import provincias from './provincias'
import rutas from './rutas'
import selectorCliente from './selectorCliente'
import stocks from './stocks'
import subpresentaciones from './subpresentaciones'
import tarifa from './tarifasEnvioPortes'
import textosVentas from './textosVentas'
import tiposNif from './tiposNif'
import tiposPedido from './tiposPedido'
import tiras from './tiras'
import transportistas from './transportistas'
import usuarioshijos from './usuariosHijos'
import widgets from './widgets'

export default combineReducers({
  articulos,
  articulo,
  pedidos,
  informes,
  messages,
  auth,
  loader,
  portal,
  precios,
  stocks,
  listasCompra,
  descripcion,
  modalGenerica,
  pedidosAnteriores,
  pedidosPendientes,
  contacto,
  listadoArticulos,
  avisos,
  formasEnvio,
  domiciliosEnvio,
  almacenes,
  rutas,
  galeria,
  widgets,
  informesFiltroLov,
  provincias,
  estados,
  expedientes,
  tiposNif,
  banners,
  imagen,
  migas,
  agrupaciones,
  tiras,
  formasPago,
  modular,
  tiposPedido,
  comunidadesAutonomas,
  subpresentaciones,
  familias,
  textosVentas,
  presentaciones,
  usuarioshijos,
  efacturaCompras,
  efacturaVentas,
  organizacionesCompras,
  ofertasMultiples,
  transportistas,
  festivos,
  tarifa,
  languageSelector,
  plantillas,
  ofertasWeb,
  articulosKit,
  articulosConjunto,
  selectorCliente,
})
